/**
 * Story 10.9 — FONTE ÚNICA do destino dos documentos legais.
 *
 * Existe porque há TRÊS chamadores reais do mesmo destino (rodapé, passo 4 do checkout e
 * formulário de registo). Foi por cada um declarar o caminho à mão que nasceram os dois links
 * mortos do starter no registo (prefixo `content`, rotas que nunca existiram e serviam 404). Aqui
 * o caminho é declarado uma vez e importado — dados puros, nunca JSX, para correr sob o
 * `environment: "node"` do vitest (idioma do `trader-menu-view-model.ts`).
 *
 * O slug fica em INGLÊS de propósito: `/privacy-policy` é o URL que a produção
 * (virtualeurope.net) publica e indexa — paridade de URL ganha à convenção PT das rotas novas.
 * O rótulo VISÍVEL é PT-BR, ao contrário da produção (que renderiza "Privacy Policy" por usar o
 * `post_title`): superfície visível em PT-BR é regra da casa.
 */

/**
 * Rota interna da política de privacidade (começa por `/`, sem barra final, nunca `"#"`).
 *
 * A produção serve o URL COM barra final (`/privacy-policy/`, o `guid` do post 3 e o que está
 * indexado). Aqui fica sem, porque é a forma canónica do Next: o `trailingSlash` está desligado,
 * logo `/privacy-policy/` responde 308 para esta. A paridade é do caminho, não do carácter final —
 * e o salto 308 do URL hoje indexado é ponto a verificar no cutover (Épico 9).
 */
export const PRIVACY_POLICY_PATH = "/privacy-policy"

/** Rótulo visível do destino, em PT-BR — serve de texto-âncora e de `<h1>` da própria página. */
export const PRIVACY_POLICY_LABEL = "Política de Privacidade"

/**
 * Story 10.12 — rota interna dos Termos de Uso.
 *
 * O slug fica com o UNDERSCORE da produção (`/reembolso_devolucoes`, post 11): é o URL publicado e
 * indexado, e a paridade de URL ganha à convenção PT das rotas novas — a mesma decisão já tomada
 * para `/privacy-policy`. Sem barra final, pela mesma razão (o `trailingSlash` está desligado).
 */
export const TERMS_PATH = "/reembolso_devolucoes"

/**
 * Rótulo visível do destino: é o `post_title` do post 11, tal e qual. O nome "Termos de Uso" é do
 * épico, não da fonte — não aparece em superfície visível.
 */
export const TERMS_LABEL = "Política de reembolso e devoluções"

/**
 * As duas metades da frase que a produção RENDERIZA acima da checkbox obrigatória do checkout.
 *
 * PROVENIÊNCIA: `ovbsi_posts` post id `9`, slug `finalizar-compra` — a página de checkout da
 * produção (`woocommerce_checkout_page_id = '9'`). O `post_content` desse post não é um template:
 * é o bloco JÁ RENDERIZADO que o comprador vê, guardado. Markup da fonte:
 *   `Li e Concordo com o Site <a href="https://virtualeurope.net/reembolso_devolucoes/"
 *    target="_blank">termos e condições</a>&nbsp;<abbr title="obrigatório">*</abbr>`
 *
 * AVISO (armadilha que já custou uma reversão desta story): NÃO derivar esta frase do
 * `templates/checkout/terms.php` do core do WooCommerce nem do catálogo `woocommerce-pt_BR.po`
 * ("Li e concordo com o(s) %s do site"). Essa receita nunca chegou a nenhum ecrã: a produção
 * substitui o bloco e a âncora está em português. O resultado SERVIDO manda sobre a receita do
 * plugin. As maiúsculas de "Concordo" e "Site" são da fonte — não "arrumar" (há teste a prendê-las).
 */
export const TERMS_CHECKBOX_PREFIX = "Li e Concordo com o Site"

/** A âncora da frase, também verbatim do post 9 — distinta do `TERMS_LABEL` de propósito. */
export const TERMS_CHECKBOX_LINK_LABEL = "termos e condições"
